import React from "react";

const MiniLoader = () => {
    return (
        <div className="loadingio-eclipse">
            <div className="ldio-rpinwye8j0b">
                <div>
                </div>
            </div>
        </div>
    )
}

export default MiniLoader